define.alias("shared/utils/canvas-video-player", "calendar/utils/canvas-video-player");